<template>
    <div class="Communique_container">
        <template v-if="!loadMore">
            <div class="column_list">
                <ul>
                    <li v-for="(item,index) in channelList" :key="index"
                        @click="item.url ? goDetail(item.url) : 'javascrip:;'"
                    >
                        <div class="release_info">
                            <div>
                                <YD-image src="icon/新闻公告"></YD-image>
                                <span>官方公告</span>
                                <span class="sign" v-if="item.isOfficial">红头</span>
                            </div>
                            <div class="release_time">{{item.addDate | dateFormat('yyyy年M月d日发布')}}</div>
                        </div>
                        <div class="communique_content">
                            <div class="communique_left">
                                <div class="communique_title">{{item.title}}</div>
                                <template v-if="item.haveBody">
                                    <div class="communique_files" v-if="item.fileCount > 0">
                                        包含{{item.fileCount}}个附件：
                                        <template v-for="fileItem in item.files">{{textEncryption(fileItem, 10, 11)}} </template>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="communique_files" v-if="item.fileCount > 1">
                                        包含{{item.fileCount - 1}}个附件：
                                        <template v-for="(fileItem,fileIndex) in item.files">
                                            <template v-if="fileIndex > 0">{{textEncryption(fileItem, 10, 11)}} </template>
                                        </template>
                                    </div>
                                </template>
                            </div>
                            <YD-image :src="item.fileCount > 0 ? 'match_detail/icon附件文档' : 'match_detail/icon通知'"></YD-image>
                        </div>
                    </li>
                </ul>
            </div>
        </template>
        <template v-else>
            <Text-prompt :text="loadMore" noDataImg="no_data/暂无内容@2x.png"></Text-prompt>
        </template>
    </div>
</template>
<script>
import tools from '@/common/tools.js';
import appInteraction from '@/common/appInteraction.js';
export default {
    props:{
        channelUrl:{
            type: String,
            default: ''
        }
    },
    data(){
        return {
            channelList:[],
            loadMore: "加载中..."
        }
    },
    created(){
        this.getNewsList();
    },
    methods:{
        textEncryption: tools.encryption,
        getNewsList(){
            if (this.channelUrl) {
                this.$api.json(this.channelUrl).then(data=>{
                    this.channelList = data.contents || [];
                    this.loadMore = this.channelList.length > 0 ? "" : "无数据";
                }).catch(()=>{
                    this.loadMore = "数据加载失败";
                })
            } else {
                this.loadMore = "无数据";
            }
        },
        goDetail(url){
            appInteraction.webviewOpenUrl(this.cmsIsDomain(url));
        },
        cmsIsDomain(url){
            if(!(/^http|https/.test(url))){
                url = process.env.VUE_APP_CMS_URL + url;
            }
            return url;
        }
    }
}
</script>
<style lang="scss" scoped>
.Communique_container{
    width: 100%;
    height: auto;
    .column_list{
        width: 100%;
        height: auto;
        padding: 40px 0 40px 40px;
        box-sizing: border-box;
        ul li{
            width: 100%;
            height: auto;
            padding-right: 40px;
            box-sizing: border-box;
            border-bottom: 1px #F0F0F0 solid;
            margin-bottom: 33px;
            &:last-of-type{
                border-bottom: none;
                margin-bottom: 0;
            }
            .release_info{
                display: flex;
                align-items: center;
                justify-content: space-between;
                img{
                    width: 32px;
                    height: 32px;
                    margin-right: 14px;
                }
                div{
                    font-size: 24px;
                    color: #41454D;
                    font-weight: 400;
                    &.release_time{
                        color: #999999;
                    }
                }
                .sign{
                    @include line-height(40px);
                    font-size: 24px;
                    color: #F06E43;
                    font-weight: 400;
                    padding: 0 8px;
                    background: #FFE9E2;
                    border-radius: 4px;
                    margin-left: 12px;
                }
            }
            .communique_content{
                padding: 32px 0 34px;
                display: flex;
                justify-content: space-between;
                .communique_left{
                    width: 530px;
                }
                .communique_title{
                    width: 420px;
                    min-height: 88px;
                    font-size: 32px;
                    color: #1B1C1E;
                    font-weight: 500;
                    line-height: 44px;
                }
                .communique_files{
                    width: 100%;
                    @include ellipsis;
                    font-size: 24px;
                    color: #666666;
                    font-weight: 400;
                    line-height: 34px;
                }
                img{
                    width: 128px;
                    height: 128px;
                }
            }
        }
    }
}
</style>